/** GLOW 플랫폼 관리자(ADMIN · SYSTEM) — userRoleCd 또는 roles(authorCd) 기준 */
export function isGlowPlatformAdmin(user) {
  if (!user) return false;
  const roleCd = normalizePlatformAdminCode(user.userRoleCd);
  if (roleCd === 'ADMIN' || roleCd === 'SYSTEM') return true;
  const roles = Array.isArray(user.roles) ? user.roles : [];
  return roles.some((role) => {
    const v = normalizePlatformAdminCode(role);
    return v === 'ADMIN' || v === 'SYSTEM';
  });
}

function normalizePlatformAdminCode(raw) {
  return String(raw || '').trim().toUpperCase().replace(/^ROLE_/, '');
}
